export function randomRgba(randomOpacity) {
    const round = Math.round;
    const random = Math.random;
    const s = 255;
    return `rgba(${round(random() * s)},${round(random() * s)},${round(random() * s)},${randomOpacity ? random().toFixed(1) : 1})`;
}
